import { Control, useFieldArray } from 'react-hook-form'
import { MEDIATEKA_DOWNLOAD } from '@/constants/urls'
import { IRange, IAnswer } from '@/models'
import { Button, Row, Text } from '@/components/ui'
import s from './question-types.module.scss'

interface IRangeQuestionProps {
  question: IRange
  control: Control
  watch: any
}

const RangeQuestion = ({ question, control, watch }: IRangeQuestionProps) => {
  const { append, remove } = useFieldArray({ control, name: `${question.id}` })
  const rangeValues = watch(`${question.id}`)

  const isSelected = (answerId: string): boolean => {
    if (!rangeValues?.length) return false
    return rangeValues.some((v: IAnswer) => v.uuid === answerId)
  }

  const getOrderNumber = (answerId: string): number => rangeValues.findIndex((v: IAnswer) => v.uuid === answerId) + 1

  return (
    <div className={s['range-question']}>
      <Button
        view='primary'
        color='red'
        className={s['question__reset-button']}
        onClick={() => remove(question.answers_objects.map((v: IAnswer, i: number) => i))}
        disabled={!rangeValues?.length}
      >
        Сбросить порядок
      </Button>
      <Row row={20} className={s['answers-list']}>
        {question.answers_objects.map((answer: any) => (
          <div key={answer.uuid} className={s['answers-list__item']} onClick={() => append(answer)}>
            <Text>{answer.title}</Text>
            {answer?.image_id && (
              <div className={s.image}>
                <img src={`${MEDIATEKA_DOWNLOAD}/${answer.image_id}`} alt='Изображение объекта ранжирования' />
              </div>
            )}
            {isSelected(answer.uuid) && <div className={s.badge}>{getOrderNumber(answer.uuid)}</div>}
          </div>
        ))}
      </Row>
    </div>
  )
}

export default RangeQuestion
